import { render, staticRenderFns } from "./SchoolInfoRow.vue?vue&type=template&id=42df4788"
import script from "./SchoolInfoRow.vue?vue&type=script&lang=js"
export * from "./SchoolInfoRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports